import {BlogModuleCard} from './blog-module-card.react-component';
import {useI18n} from '@udemy-v2/i18n';
import classNames from 'classnames';
import styles from './blog-module.module.scss';
import {ContentArea, ContentGrid, ContentGridItem} from '@udemy-v2/react-layout-components';

const CARDS = [
    {
        tag: 'Pitching',
        description: 'How to Write an Elevator Pitch',
        image: 'https://frontends.udemycdn.com/frontends-landing-pages/60-day-hustle/images/blog-module/blog-1.png',
        className: 'teal',
        url: 'https://blog.udemy.com/how-to-write-elevator-pitch-with-examples/',
    },
    {
        tag: 'Branding',
        description: 'How to Build Customer Loyalty',
        image: 'https://frontends.udemycdn.com/frontends-landing-pages/60-day-hustle/images/blog-module/blog-2.png',
        className: 'orange',
        url: 'https://blog.udemy.com/build-customer-loyalty-through-brand-experience/',
    },
    {
        tag: 'Sales',
        description: 'Sales Techniques That Close',
        image: 'https://frontends.udemycdn.com/frontends-landing-pages/60-day-hustle/images/blog-module/blog-3.png',
        className: 'purple',
        url: 'https://blog.udemy.com/sales-techniques-that-close-with-examples-you-can-use/',
    },
    {
        tag: 'Scalability',
        description: 'How to Scale Without Burning Out',
        image: 'https://frontends.udemycdn.com/frontends-landing-pages/60-day-hustle/images/blog-module/blog-4.png',
        className: 'purple-light',
        url: 'https://blog.udemy.com/small-business-growth-strategies-how-to-scale/',
    },
    {
        tag: 'Upskilling',
        description: '6 Business Skills from 60DH Stars',
        image: 'https://frontends.udemycdn.com/frontends-landing-pages/60-day-hustle/images/blog-module/blog-7.png',
        className: 'purple',
        url: 'https://blog.udemy.com/business-skills-courses-60-day-hustle/',
    },
    {
        tag: 'Stories',
        description: "Winner Brittany Caldwell's Success Story",
        image: 'https://frontends.udemycdn.com/frontends-landing-pages/60-day-hustle/images/blog-module/blog-5.png',
        className: 'teal',
        url: 'https://blog.udemy.com/brittany-caldwell-60-day-hustle/',
    },
    {
        tag: 'Stories',
        description: 'How Michelle Delamor Built a Media Empire',
        image: 'https://frontends.udemycdn.com/frontends-landing-pages/60-day-hustle/images/blog-module/blog-6.png',
        className: 'orange',
        url: 'https://blog.udemy.com/michelle-delamor-entrepreneur-guide/',
    },
];

export function BlogModule() {
    const {gettext} = useI18n();

    return (
        <>
            <div className={classNames('ud-heading-xxl', styles['blog-title'])}>
                {gettext('Explore more tips and')}
                <br />
                {gettext('techniques for your hustle')}
            </div>
            <ContentArea>
                <ContentGrid className={styles['blog-module']}>
                    {CARDS.map((card, index) => (
                        <ContentGridItem
                            key={`${card.url}-${index}`}
                            className={styles['blog-module-item']}
                            defaultSpan={4}
                            wideSpan={4}
                            lgSpan={3}
                        >
                            <BlogModuleCard
                                color={card.className}
                                tag={card.tag}
                                description={card.description}
                                image={card.image}
                                url={card.url}
                            />
                        </ContentGridItem>
                    ))}
                </ContentGrid>
            </ContentArea>
        </>
    );
}
